import { render, staticRenderFns } from "./chooseRole.vue?vue&type=template&id=3176dcfe&scoped=true"
import script from "./chooseRole.vue?vue&type=script&lang=js"
export * from "./chooseRole.vue?vue&type=script&lang=js"
import style0 from "./chooseRole.vue?vue&type=style&index=0&id=3176dcfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3176dcfe",
  null
  
)

export default component.exports